import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import DashboardIcon from '@material-ui/icons/Dashboard';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import CategoryIcon from '@material-ui/icons/Category';
import SettingsIcon from '@material-ui/icons/Settings';

import { Profile, SidebarNav } from './components';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;

  const classes = useStyles();

  const pages = [
    {
      title: 'داشبورد',
      href: '/dashboard',
      icon: <DashboardIcon />,
      collapse: false
    },
    {
      title: 'نظرات و شکایات',
      href: '/complaints',
      icon: <RecordVoiceOverIcon />,
      collapse: false
    },
    // {
    //   title: 'مدیریت محتوا',
    //   icon: <CategoryIcon />,
    //   collapse: [
    //     {
    //       title: 'دسته بندی ها',
    //       href: '/categories',
    //       icon: <FiberManualRecordIcon />,
    //     },
    //     {
    //       title: 'برندها',
    //       href: '/brands',
    //       icon: <FiberManualRecordIcon />,
    //     },
    //     {
    //       title: 'محصولات',
    //       href: '/products',
    //       icon: <FiberManualRecordIcon />,
    //     }
    //   ]
    // },
    // {
    //   title: 'همکار فروش',
    //   href: '/sellers',
    //   icon: <AssignmentIndIcon />,
    //   collapse: false
    // },
    // {
    //   title: 'بیمه',
    //   href: '/insurance',
    //   icon: <VerifiedUserIcon />,
    //   collapse: false
    // },
    // {
    //   title: 'جایزه / پاداش',
    //   href: '/reports',
    //   icon: <CardGiftcardIcon />,
    //   collapse: false
    // },
    {
      title: 'حساب کاربری',
      href: '/account',
      icon: <AccountBoxIcon />,
      collapse: false
    },
    {
      title: 'تنظیمات',
      href: '/settings',
      icon: <SettingsIcon />,
      collapse: false
    }
  ];

  return (
    <Drawer
      anchor="right"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(classes.root, className)}
      >
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
